import { subDays } from 'date-fns';
import Button from '../components/Button';
import { DEFAULT_DATE_FORMATE } from '../constents';
import DatePickerCalander from './DatePickerCalander';
import Select from 'react-select';

function DurationSearchHead({
  duration = '7D',
  startDate = null,
  endDate = null,
  isDateRange = false,
  isProviderDd = false,
  options = [],
  selectedProvider = '',
  setData = () => {},
  openPopup = () => {},
}) {
  return (
    <div className="bnc-mn-hdr">
      <div className="bill-dt-main-con">
        <div className="bill-days-blk">
          <span className="intake-head-inpt-main">
            <span className="intake-head-hedding">Referral Date:</span>
            <span className="intake-head-inpt-sec">
              <input
                type="radio"
                name="radio2"
                onChange={() =>
                  setData((prev) => ({
                    ...prev,
                    filterValue: 'ALL',
                    isDateRange: false,
                    startDate: null,
                    endDate: null,
                  }))
                }
                checked={duration === 'ALL'}
              />
              <span className="">All</span>
            </span>

            <span className="intake-head-inpt-sec">
              <input
                type="radio"
                name="radio2"
                onChange={() =>
                  setData((prev) => ({
                    ...prev,
                    filterValue: '90D',
                    isDateRange: false,
                    startDate: subDays(new Date(), 90),
                    endDate: new Date(),
                  }))
                }
                checked={duration === '90D'}
              />
              <span className="">90 days</span>
            </span>

            <span className="intake-head-inpt-sec">
              <input
                type="radio"
                name="radio2"
                onChange={() =>
                  setData((prev) => ({
                    ...prev,
                    filterValue: '60D',
                    isDateRange: false,
                    startDate: subDays(new Date(), 60),
                    endDate: new Date(),
                  }))
                }
                checked={duration === '60D'}
              />
              <span className="">60 days</span>
            </span>

            <span className="intake-head-inpt-sec">
              <input
                type="radio"
                name="radio2"
                onChange={() =>
                  setData((prev) => ({
                    ...prev,
                    filterValue: '30D',
                    isDateRange: false,
                    startDate: subDays(new Date(), 30),
                    endDate: new Date(),
                  }))
                }
                checked={duration === '30D'}
              />
              <span className="">30 days</span>
            </span>
            <span className="intake-head-inpt-sec">
              <input
                type="radio"
                name="radio2"
                onChange={() =>
                  setData((prev) => ({
                    ...prev,
                    filterValue: '7D',
                    isDateRange: false,
                    startDate: subDays(new Date(), 7),
                    endDate: new Date(),
                  }))
                }
                checked={duration === '7D'}
              />
              <span className="">7 days</span>
            </span>

            <div className="intake-serch-calander-sec">
              <span className="intake-head-inpt-sec">
                <input
                  type="radio"
                  name="radio2"
                  onChange={() =>
                    setData((prev) => ({
                      ...prev,
                      filterValue: 'D',
                      isDateRange: true,
                      startDate: null,
                      endDate: null,
                    }))
                  }
                />
              </span>
              <span className="intake-serch-calander">
                <DatePickerCalander
                  selectedDate={startDate}
                  setSelectedDate={(date) =>
                    setData((prev) => ({ ...prev, startDate: date }))
                  }
                  className="add-task-date-picker"
                  style={{
                    width: '75px',
                  }}
                  dateFormat={DEFAULT_DATE_FORMATE}
                  maxDate={endDate}
                  editFlag={!isDateRange}
                />
              </span>
              <span className="date-sep-blu-hdr">-</span>
              <span className="intake-serch-calander">
                <DatePickerCalander
                  selectedDate={endDate}
                  setSelectedDate={(date) =>
                    setData((prev) => ({ ...prev, endDate: date }))
                  }
                  className="add-task-date-picker"
                  style={{
                    width: '75px',
                  }}
                  dateFormat={DEFAULT_DATE_FORMATE}
                  minDate={startDate}
                  editFlag={!isDateRange}
                />
              </span>
              {isProviderDd && (
                <span className="intake-serch-calander">
                  <Select
                    value={selectedProvider}
                    options={options}
                    onChange={(option) => {
                      setData((prev) => ({ ...prev, provider: option }));
                    }}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </span>
              )}
            </div>
          </span>
        </div>
        <Button variant="primary" onClick={() => openPopup()}>
          New Referral
        </Button>
      </div>
    </div>
  );
}

export default DurationSearchHead;
